import { makeStyles } from "e100-react-components";

export const useStyles = makeStyles(({ spacing }) => ({
  container: {
    padding: spacing(2),
  },
}));
